module.exports = __webpack_public_path__ + "img/banner-servicos-responsivo.3f56ad2e.jpg";